import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import styled, { css } from 'styled-components';
export var MonthViewContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  /* width: 100%;\n  max-width: 310px; */\n  display: flex;\n  flex-wrap: wrap;\n  align-content: stretch;\n"])));
export var MonthText = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1 0 33.33%;\n  cursor: pointer;\n  height: 75px;\n  display: flex;\n  outline: none;\n  transition: font-size 100ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  font-size: 16px;\n  font-family: ", ";\n  color: ", ";\n\n  &:focus {\n    color: ", ";\n    font-weight: 500;\n  }\n\n  ", ";\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.fontRegular;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.calendar.textColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.calendar.selectedTextColor;
}, function (_ref4) {
  var selected = _ref4.selected;
  return selected && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      font-family: ", ";\n      color: ", ";\n      font-size: 24px;\n      font-weight: 500;\n    "])), function (_ref5) {
    var theme = _ref5.theme;
    return theme.fonts.fontSemiBold;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.calendar.selectedTextColor;
  });
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      color: ", ";\n      pointer-events: none;\n    "])), function (_ref8) {
    var theme = _ref8.theme;
    return theme.calendar.disabledTextColor;
  });
});